import { toMoney } from 'vanilla-masker';

const MONEY_MASK_SETTINGS = {
  precision: 0,
  separator: '.',
  delimiter: ',',
  unit: '',
  suffixUnit: '',
};

const getValue = (value, oldValue) => {
  let sanitized = _sanitize(value, MONEY_MASK_SETTINGS);

  if (MONEY_MASK_SETTINGS.suffixUnit && oldValue && sanitized) {
    if (sanitized.length === oldValue.length - 1) {
      let cleared = removeNotNumbers(sanitized);
      sanitized = cleared.substr(0, cleared.length - 1);
    }
  }

  let masked = toMoney(sanitized, MONEY_MASK_SETTINGS);

  return masked;
};

const getRawValue = (maskedValue) => {
  let normalized = removeNotNumbers(maskedValue);

  let dotPosition = normalized.length - MONEY_MASK_SETTINGS.precision;
  normalized = _insert(normalized, dotPosition, '.');

  return Number(normalized);
};

const removeNotNumbers = (text) => {
  return text.replace(/[^0-9]+/g, '');
};

const _sanitize = (value, settings) => {
  if (typeof value === 'number') {
    return value.toFixed(settings.precision);
  }

  return value;
};

const _insert = (text, index, string) => {
  if (index > 0) {
    return (
      text.substring(0, index) + string + text.substring(index, text.length)
    );
  } else {
    return string + text;
  }
};

export const useMoneyMask = () => {
  return {
    getValue,
    getRawValue,
  };
};
